import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2137aaa1")

_pushScopeId("data-v-2137aaa1")
const _hoisted_1 = { class: "w-40" }
const _hoisted_2 = { class: "relative flex-grow datepicker--wrapper" }
const _hoisted_3 = {
  key: 3,
  class: "text-error-detail"
}
const _hoisted_4 = { class: "text-error" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_v_date_picker = _resolveComponent("v-date-picker")
  const _component_MonthInput = _resolveComponent("MonthInput")
  const _component_DateInput = _resolveComponent("DateInput")

  return (_openBlock(), _createBlock("div", {
    class: ["flex items-center", $props.justifyCenter ? 'justify-center' : '']
  }, [
    ($props.isIconChevronLeft)
      ? (_openBlock(), _createBlock("a", {
          key: 0,
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.onNextDate(-1))),
          class: "cursor-pointer hover:opacity-75"
        }, [
          _createVNode("img", {
            src: $setup.iconChevronLeft,
            alt: ""
          }, null, 8, ["src"])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_1, [
      ($props.isRange)
        ? (_openBlock(), _createBlock(_component_v_date_picker, {
            key: 0,
            modelValue: $setup.date,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ($setup.date = $event)),
            masks: $setup.masks,
            mode: "date",
            "is-range": $props.isRange,
            class: $props.disabled ? 'disable' : '',
            onDayclick: $setup.onDayClick
          }, {
            default: _withId(({ inputValue, inputEvents }) => [
              _createVNode("div", _hoisted_2, [
                _createVNode("input", _mergeProps({
                  class: "px-2 py-1 border rounded focus:outline-none focus:border-blue-300 flex-grow h-12 test-base",
                  value: 
                $props.isRange
                  ? inputValue.start + ` ～ ` + inputValue.end
                  : inputValue
              ,
                  style: $setup.styleInput
                }, _toHandlers($props.isRange ? inputEvents.start : inputEvents), {
                  onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.handleChange && $setup.handleChange(...args)))
                }), null, 16, ["value"]),
                _createVNode("img", {
                  class: "mx-2 absolute pointer-events-non datepicker--icon",
                  src: $setup.DatePickerIcon,
                  alt: "",
                  srcset: ""
                }, null, 8, ["src"])
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "masks", "is-range", "class", "onDayclick"]))
        : _createCommentVNode("", true),
      ($props.type === 'month')
        ? (_openBlock(), _createBlock(_component_MonthInput, {
            key: 1,
            modelValue: $setup.date,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ($setup.date = $event)),
            disabled: $props.disabled,
            placeholder: $props.placeholder,
            format: $props.format
          }, null, 8, ["modelValue", "disabled", "placeholder", "format"]))
        : (_openBlock(), _createBlock(_component_DateInput, {
            key: 2,
            modelValue: $setup.date,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ($setup.date = $event)),
            format: $props.format,
            disabled: $props.disabled
          }, null, 8, ["modelValue", "format", "disabled"])),
      ($props.validated && ($setup.errorMessage || $props.errorServer))
        ? (_openBlock(), _createBlock("span", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("span", null, _toDisplayString($setup.errorMessage || $props.errorServer), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    ($props.isIconChevronRight)
      ? (_openBlock(), _createBlock("a", {
          key: 1,
          onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.onNextDate(1))),
          class: "cursor-pointer hover:opacity-75"
        }, [
          _createVNode("img", {
            src: $setup.iconChevronRight,
            alt: ""
          }, null, 8, ["src"])
        ]))
      : _createCommentVNode("", true)
  ], 2))
})